import { format, makeApiCall } from "@swiggy-private/js-utils";

// dls
import { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";

// context
import type { ITableConfig } from "@swiggy-private/portal-dineout-context";
import { API_ENDPOINTS, GANDALF_API_HOST } from "../constants/api";
import { customApiCall, IOptions } from "../utils/api";
import { IMenuDataInfo } from "../utils/types";

export const fetchMenuData = async (params: ITableConfig, _makeApiCall: typeof makeApiCall) => {
    const { restaurantId, tableId } = params || {};
    const endpoint = format(API_ENDPOINTS.MENU_PL_API, restaurantId, restaurantId, tableId);
    const response = await customApiCall<IMenuDataInfo>({
        _makeApiCall: _makeApiCall,
        apiHost: GANDALF_API_HOST,
        apiEndpoint: endpoint,
    });

    return response;
};

export const getRestaurantConfig = async (options: IOptions, _makeApiCall: typeof makeApiCall) => {
    const response = await customApiCall<{ cards: IPLWidgetControllerCards[] }>({
        _makeApiCall: _makeApiCall,
        apiHost: GANDALF_API_HOST,
        apiEndpoint: API_ENDPOINTS.GET_RESTAURANT_CONFIG,
        opts: options,
    });

    return response;
};
